export const getMobilePortraitViewType = state => {
  return state.appState.mobileView.portraitViewType;
};
export const getOpenViews = state => {
  return state.appState.mobileLandscapeOpenViews;
};
export const getActiveViewId = state => state.appState.mobileLandscapeOpenViews.activeView;
